export const VALID_TOKEN = "validToken";
export const VALID_PHONE = "validPhone";
export const VALID_OTP = "validOtp";
export const USER_INFO = "userInfo";
export const GET_GAME = "getGame";
export const GIFT_LIST = "listGift";
export const DRAW_GAME = "drawGame";
export const HISTORY = "history";
export const RETRY_GIFT = "retryGift";
export const INSERT_ADDRESS = "insertAddress";
export const LIST_CITY = "listCity";
export const LIST_DISTRICT = "listDistrict";
export const LIST_WARD = "listWard";
export const SHOWING = "showing";
